<template>
  <div>
    <new-card v-if="editing" class="edit-pane" ref="newCard"></new-card>

    <grid-layout
      :layout.sync="layout"
      ref="gridlayout"
      :col-num="grid.colNum"
      :row-height="grid.rowHeight"
      :is-draggable="editing"
      :is-resizable="editing"
      :is-mirrored="false"
      :vertical-compact="true"
      :margin="[10, 10]"
      :use-css-transforms="true"
    >

      <grid-item v-for="item in layout"
                 :x="item.x"
                 :y="item.y"
                 :w="item.w"
                 :h="item.h"
                 :i="item.i"
                 :key="item.i"
                 >
        <div class="widget-wrapper">
          <div :is="getWidgetType(item)"
               :definition="item"
               :config="item.config"
               :editing="editing"/>
          <span v-if="editing" class="remove" @click="removeItem(item.i)">x</span>
        </div>
      </grid-item>
    </grid-layout>
  </div>
</template>
<script>

import VueGridLayout from 'vue-grid-layout'
import DevicesWidget from './DevicesWidget.vue'
import EnrollmentWidget from './EnrollmentWidget.vue'
import IncidentsWidget from './IncidentsWidget.vue'
import ConfigurationWidget from './ConfigurationWidget.vue'
import MetabaseWidget from './MetabaseWidget.vue'
import NewCard from './NewCards/NewCard.vue'

export default {
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    DevicesWidget,
    EnrollmentWidget,
    IncidentsWidget,
    ConfigurationWidget,
    MetabaseWidget,
    NewCard
  },
  props: {
    widgets: {
      type: Array
    },
    editing: {
      type: Boolean,
      default: false
    },
    displayPanels: {
      type: Boolean
    },
    gridConfig: {
      type: Object
    }
  },
  data() {
    return {
      layout: this.widgets,
      editStates: [],
      nextIndex: Math.max.apply(Math, this.widgets.map(function(o) { return o.i; })) + 1,
      grid: Object.assign({
        colNum: 12,
        rowHeight: 100
      }, this.gridConfig)
    }
  },
  methods: {
    getWidgetType: function(widget) {
      if (!this.displayPanels) {
        return 'ConfigurationWidget'
      }
      return widget.type;
    },
    saveState: function() {
      this.editStates.push(JSON.parse(JSON.stringify(this.layout)));
    },
    restoreState: function() {
      this.layout = this.editStates.pop()
    },
    addCard: function (config) {
      // If we just used config here, it would lock in the coordinates even if we removed cards later
      let card = Object.assign({}, config)
      Object.assign(card, this.findAvailableCoordinates(card.h, card.y));
      Object.assign(card, {i: this.nextIndex});
      this.layout.push(card);
      // Increment the counter to ensure key is always unique.
      this.nextIndex++;
    },

    findAvailableCoordinates: function (h, w) {
      var nextRow = 0;
      this.layout.forEach(function(widget) {
        if (nextRow < widget.y + widget.h) {
          nextRow = widget.y + widget.h
        }
      });
      return {
        x: 0,
        y: nextRow
      };
    },
    getNewCardDefault(type) {
      switch (type) {
        case "DevicesWidget":
          return {
            label: 'Devices',
            type: 'DevicesWidget',
            h: 4,
            w: 4
          };
        case "IncidentsWidget":
          return {
            label: 'Incidents',
            type: 'IncidentsWidget',
            h: 4,
            w: 8
          };
        case "EnrollmentWidget":
          return {
            label: 'Enrollment',
            type: 'EnrollmentWidget',
            h: 4,
            w: 8,
          }
        default:
          return {};
      }
    },
    removeItem: function (val) {
      const index = this.layout.map(item => item.i).indexOf(val);
      this.layout.splice(index, 1);
    },
  }
}
</script>

<style scoped>
  .vue-grid-item {
    border-radius: 10px;
    border: 1px solid #f0f0f0;
    box-shadow: 1px 1px 5px #f0f0f0;
    padding: 10px;
  }

  .vue-draggable-handle {
    position: absolute;
    width: 20px;
    height: 20px;
    bottom: 0;
    right: 0;
    background: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='10'><circle cx='5' cy='5' r='5' fill='#999999'/></svg>") no-repeat;
    background-position: bottom right;
    padding: 0 8px 8px 0;
    background-repeat: no-repeat;
    background-origin: content-box;
    box-sizing: border-box;
    cursor: pointer;
  }

  .widget-wrapper {
    overflow: auto;
    height: 100%;
  }

  .vue-grid-item .resizing {
    opacity: 0.9;
  }
  .vue-grid-item .static {
    background: #cce;
  }
  .remove {
    position: absolute;
    right: -8px;
    top: -8px;
    cursor: pointer;
    background: #95001a;
    padding: 2px 0 0 1px;
    color: #FFFFFF;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    text-align: center;
    text-transform: capitalize;
    font-weight: bold;
    font-size: 8px;
  }
  .layoutJSON {
    background: #ddd;
    border: 1px solid black;
    margin-top: 10px;
    padding: 10px;
  }
  .columns {
    -moz-columns: 120px;
    -webkit-columns: 120px;
    columns: 120px;
  }
</style>